.secondary {
  position: fixed;
  z-index: var(--z-index-secondary-nav);
  top: 0;
  left: 0;
  height: 100%;
  width: var(--secondary-nav-width);
  padding: 75px 11px 15px 11px;
  background-color: var(--brand-blue-400);
  background-color: light-dark(var(--brand-blue-400), var(--brand-grey-700));
  border-right: 1px solid light-dark(transparent, var(--brand-grey-500));
  transition: width var(--secondary-nav-transition-duration) var(--secondary-nav-transition-easing);
}

.groupWrapper {
  margin-bottom: 8px;
}

.hoverMenuWrapper {
  position: relative;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
